<template>
  <div>
    <transition :duration="5500">
      <b-container fluid>
        <h1 align="center" id="jump-to-header">Move / Relocate / Transfer</h1>
        <!-- User Interface controls -->
        <b-card bg-variant="light">
          <b-row>
            <b-col b-col md="6" class="my-1">
              <h2>From</h2>
                <ams-select-table v-if="transfer_from_ams_fields"
                  :heading="transfer_from_heading"
                  :ams_api_path="ams_api_path"
                  :ams_type="transfer_from"
                  :ams_fields="transfer_from_ams_fields"
                  :describe_belongs_to="transfer_from_describe_belongs_to"
                  :filtering="filtering"
                  :select_mode="transfer_from_mode_selection"
                  @selectedRows="selectTransferFromRows"
                />
            </b-col>
            <b-col b-col md="5" class="my-1">
              <h2>To</h2>
                <ams-select-table v-if="transfer_to_ams_fields"
                  :heading="transfer_to_heading"
                  :ams_api_path="ams_api_path"
                  :ams_type="transfer_to"
                  :ams_fields="transfer_to_ams_fields"
                  :select_mode="transfer_to_mode_selection"
                  @selectedRows="selectTransferToRows"
                />
            </b-col>
            <b-col md="1">
              <data-operations
                :modified="modified"
                :can_update="canUpdate"
                :can_delete="canDelete"
                :can_help="canHelp"
                @update="doUpdate"
                @undo="doUndo"
                @delete="doDelete"
                @cancel="doCancel"
                @help="doHelp"
              ></data-operations>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </transition>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {amsSchema} from '@/schema'
import {humanize, singularize} from '@/utils'
import DataOperations from './DataOperations.vue'
import AmsSelectTable from './AmsSelectTable.vue'

export default {
  components: {
    DataOperations,
    AmsSelectTable
  },
  props: {
    transfer_from: {
      Type: String
    },
    transfer_to: {
      Type: String
    },
    filtering: {
      Type: Object
    }
  },
data () {
    return {
      ams_api_path: 'api/admin/v1/',
      modified: false,
      selected_from_rows: undefined,
      selected_to_rows: undefined,
      description: undefined,
      transfer_from_heading: undefined,
      transfer_from_mode_selection: 'multi',
      transfer_from_ams_fields: undefined,
      transfer_from_describe_belongs_to: undefined,
      transfer_to_heading: undefined,
      transfer_to_mode_selection: 'single',
      transfer_to_ams_fields: undefined,
      transfer_to_describe_belongs_to: undefined
    }
  },
  computed: {
    canUpdate() {
      return (
        this.modified &&
        this.selected_from_rows?.length > 0 &&
        this.selected_to_rows?.length > 0
      )
    },
    canHelp() {
      return true
    },
    canDelete() {
      return false
    }
  },
  methods: {
    doUpdate() {
      this.callApi()
    },
    doUndo() {
      this.selected_from_rows = undefined
      this.selected_to_rows = undefined
      this.modified = false
    },
    doCancel() {
      this.$router.go(-1)
    },
    doDelete() {
      // http_v1.delete (
      //   this.apiResourcePath()
      // ).then(response => {
      //   if( response.status == 204) {
      //     this.$router.go(-1)
      //   }
      // }).catch(error => {
      //   if( error.response && error.response.data) {
      //     var message = error.response.data.message || JSON.stringify(error.response.data)
      //     if (error.response.status === 500 ) message = "500 Server Error"
      //     this.$bvToast.toast(message, {
      //       title: 'Error',
      //       autoHideDelay: 5000,
      //       appendToast: true
      //     })
      //   }
      // })
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.transfer_from
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    relationshipIdentifier() {
       return singularize(this.transfer_to).replace(/-/g, '_') + '_id'
    },
    apiResourcePath(id) {
      return this.ams_api_path + this.transfer_from.replace(/-/g, '_') + '/' + id
    },
    callApi () {
      let relationship_identifier = this.relationshipIdentifier()
      let attr_params = {
        [relationship_identifier] : this.selected_to_rows[0].id
      }
      this.selected_from_rows.forEach( row => {
        http_v1.patch (
          this.apiResourcePath(row.id), {
            ...attr_params
          }
        ).then(() => {
          this.$router.go(-1)
        }).catch(error => {
          window.console.log(error)
          if( error.response && error.response.data) {
            var message = error.response.data.message || JSON.stringify(error.response.data)
            if (error.response.status === 500 ) message = "500 Server Error"
            this.$bvToast.toast(message, {
              title: 'Error',
              autoHideDelay: 5000,
              appendToast: true
            })
          }
        })
      })
    },
    selectTransferFromRows(items) {
      this.selected_from_rows = items
      this.modified = true
    },
    selectTransferToRows(items) {
      this.selected_to_rows = items
      this.modified = true
    }
  },
  mounted () {
    // const element = document.getElementById("jump-to-header")
    // element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })

    const transfer_from_obj = amsSchema.find( 
      el =>  
      el.type === this.transfer_from
    )
    this.transfer_from_heading = humanize(this.transfer_from)
    this.transfer_from_ams_fields = transfer_from_obj.ams_fields
    this.transfer_from_describe_belongs_to = transfer_from_obj.describe_belongs_to
  
    const transfer_to_obj = amsSchema.find( 
      el =>  
      el.type === this.transfer_to
    )
    this.transfer_to_heading = humanize(this.transfer_to)
    this.transfer_to_ams_fields = transfer_to_obj.ams_fields
    this.transfer_to_describe_belongs_to = transfer_to_obj.describe_belongs_to

    // http_v1.get(this.apiResourcePath(), {
    // }).then(response => {
    //   if( response.data) {
    //     this.attr_copy = Object.assign( {}, response.data.data.attributes)
    //     this.attr_orig = Object.assign( {}, response.data.data.attributes)
    //     this.description = belongsToDescription(
    //       response.data.data, response.data.included, this.describe_belongs_to
    //     )
    //     this.$emit('gotAttrs', this.attr_copy, this.description)
    //   }
    // }).catch(error => {
    //   if( error.response && error.response.data) {
    //       var message = error.response.data.message || JSON.stringify(error.response.data)
    //       if (error.response.status === 500 ) message = "500 Server Error"
    //       this.$bvToast.toast(message, {
    //         title: 'Error',
    //         autoHideDelay: 5000,
    //         appendToast: true
    //       })
    //     }
    //   })
  }
}
</script>